// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"educationMessage__wrapper","progress":"educationMessage__progress","message":"educationMessage__message"};